
import { createRoot, hydrateRoot } from 'react-dom/client'

export const onRouteUpdateDelayed = () => {
  // console.log("onRouteUpdateDelayed")
}

export const onRouteUpdate = (args) => {
  // console.log(args);
  // console.log("onRouteUpdate")
}

export const onPreRouteUpdate = () => {
  // console.log("onPreRouteUpdate")
}

export function replaceHydrateFunction() {
  return (element, container, callback) => {
    createRoot(container).render(element)
  }
}


export const onServiceWorkerUpdateReady = () => {

}
